import actionTypes from './actionTypes';

const INITIAL_STATE = {
  dashboardDataLoading: false,
  dashboardDataFailed: false,
  dashboardDataError: false,
  dashboardDataMessage: null,
  dashboardData: {},

  cafeAdminDashboardDataLoading: false,
  cafeAdminDashboardDataFailed: false,
  cafeAdminDashboardDataError: false,
  cafeAdminDashboardDataMessage: null,
  cafeAdminDashboardData: {}
}


export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_DASHBOARD_DATA_LOADING: {
      return {
        ...state,
        dashboardDataLoading: true,
        dashboardDataFailed: false,
        dashboardDataError: false,
        dashboardDataMessage: null,
        dashboardData: {}
      };
    };
    case actionTypes.FETCH_DASHBOARD_DATA_REJECT: {
      return {
        ...state,
        dashboardDataLoading: false,
        dashboardDataFailed: false,
        dashboardDataError: true,
        dashboardDataMessage: null,
        dashboardData: {}
      };
    };
    case actionTypes.FETCH_DASHBOARD_DATA_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        dashboardDataLoading: false,
        dashboardDataFailed: true,
        dashboardDataError: false,
        dashboardDataMessage: message,
        dashboardData: {}
      };
    };
    case actionTypes.FETCH_DASHBOARD_DATA_SUCCESS: {
      return {
        ...state,
        dashboardDataLoading: false,
        dashboardDataFailed: false,
        dashboardDataError: false,
        dashboardDataMessage: null,
        dashboardData: { ...action.payload },
      };
    };


    case actionTypes.FETCH_CAFE_ADMIN_DASHBOARD_DATA_LOADING: {
      return {
        ...state,
        cafeAdminDashboardDataLoading: true,
        cafeAdminDashboardDataFailed: false,
        cafeAdminDashboardDataError: false,
        cafeAdminDashboardDataMessage: null,
        cafeAdminDashboardData: {}
      };
    };
    case actionTypes.FETCH_CAFE_ADMIN_DASHBOARD_DATA_REJECT: {
      return {
        ...state,
        cafeAdminDashboardDataLoading: false,
        cafeAdminDashboardDataFailed: false,
        cafeAdminDashboardDataError: true,
        cafeAdminDashboardDataMessage: null,
        cafeAdminDashboardData: {}
      };
    };
    case actionTypes.FETCH_CAFE_ADMIN_DASHBOARD_DATA_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        cafeAdminDashboardDataLoading: false,
        cafeAdminDashboardDataFailed: true,
        cafeAdminDashboardDataError: false,
        cafeAdminDashboardDataMessage: message,
        cafeAdminDashboardData: {}
      };
    };
    case actionTypes.FETCH_CAFE_ADMIN_DASHBOARD_DATA_SUCCESS: {
      return {
        ...state,
        cafeAdminDashboardDataLoading: false,
        cafeAdminDashboardDataFailed: false,
        cafeAdminDashboardDataError: false,
        cafeAdminDashboardDataMessage: null,
        cafeAdminDashboardData: { ...action.payload },
      };
    };
    default:
      return state;
  }
};
